module.exports = __webpack_public_path__ + "static/media/gmd.463a421c.png";